import DrpAPI from "../../../api/drp";

const MIXIN = {
  data: () => ({
    loading: false,
  }),
  methods: {
    async adicionarProdutoNoCarrinho (item) {
      const headers = this.Helpers.iniciarRequisicao()

      const ID_USUARIO = localStorage.getItem("id")

      const params = {
        iduser: ID_USUARIO,
        pedido: item.idpedido,
        produto: item.idproduto,
        filial_origem: item.filialOrigem,
        filial_destino: item.filialDestino,
        qtde: item.qtdeSeparacao
      }

      let addComSucesso = false

      await DrpAPI.addItemPedido(headers, params)
        .then(response => {
          const token = response.data.token;
          localStorage.setItem("token", token);
          addComSucesso = ! addComSucesso
        }).catch(() => {
          this.Helpers.logout();
        })

      return addComSucesso
    },
    getDistinctDepartamentos (listaFull) {
      const departamentos = []

      listaFull.forEach(item => {
        const { id_departamento, descricao_departamento: descricao } = item

        const jaExiste = departamentos.filter(departamento => departamento.id_departamento == id_departamento)

        if (!jaExiste[0]) {
          const itemDepartamento = {id_departamento, descricao: `${id_departamento} - ${descricao}`}

          departamentos.push(itemDepartamento)
        }
      })

      return departamentos
    },
    getDistinctFornecedores (listaFull) {
      const fornecedores = []

      listaFull.forEach(item => {
        const { idfornecedor, razao_social } = item

        const jaExiste = fornecedores.filter(fornecedor => fornecedor.idfornecedor == idfornecedor)

        if (!jaExiste[0]) {
          const itemFornecedor = {idfornecedor, razao_social: `${idfornecedor} - ${razao_social}`}

          fornecedores.push(itemFornecedor)
        }
      })

      return fornecedores
    }
  }
}

export default MIXIN
